import {
  FILTERS_GROUPS_LABELS as sharedFiltersGroupsLabels,
  FILTERS_LABELS as sharedFiltersLabels
} from '../common/filtersLabels.js'

// Define only the filters labels that are different from the common ones
export const FILTERS_LABELS = {...sharedFiltersLabels}
export const FILTERS_GROUPS_LABELS = {...sharedFiltersGroupsLabels}
